import React, { useContext, useState, useRef } from 'react';
import { ReactComponent as InternalIcon } from '../../assets/icons/internal-icon.svg';
import classes from './index.module.scss';
import { useHistory } from "react-router-dom";
import { UserContext } from '../../context/User';
import Modal from '../UI/Modal';
import { somethingWentWrongNotice, replyMessageNotice } from '../UI/Notifications';
import { useForm } from 'react-hook-form';
import InternalModalContent from './ModalContents/InternalModalContent';
import { messageMassPost } from '../../api';

const InternalMsg = ({ setLoading }) => {
  const { setIsLoggedIn, setUser } = useContext(UserContext);
  const history = useHistory();
  const [show, setShow] = useState(false);
  const { register, handleSubmit, errors } = useForm();
  const [inputValue , setInputValue] = useState("all");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push("/");
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout();
    } else {
      somethingWentWrongNotice("Send Message");
    }

    setLoading(false);
  }

  const onSubmit = data => {
    setLoading(true);

    const body = {
      receiver: inputValue,
      ...data
    }

    if (!body.body) delete body.body;
    if (!body.subject) delete body.subject;

    messageMassPost("inbox", body)
      .then(() => {
        handleClose();
        replyMessageNotice("Mass Messages")
        setLoading(false);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        handleClose();
      });
  }

  const sendInternalMessage = () => {
    handleShow();
  }

  const onChangeHandler = (value) => {
    setInputValue(value.value);
  }

  return (
    <>
      <div className={classes.MessageBox}>
        <InternalIcon />
        <h5 className="mb-4">Send an Internal Message</h5>
        <p>To All Users or Businesses</p>
        <button
          className="btnSizes filledBtn"
          onClick={sendInternalMessage}
        >
          Send
        </button>
      </div>
      <Modal 
        handleClose={handleClose} 
        show={show}
        handleSubmit={handleSubmit}
        buttonLabel="Send Message"
        onSubmit={onSubmit}
      >
        <InternalModalContent 
          register={register}
          onChangeHandler={onChangeHandler}
        />
      </Modal>
    </>
  )
}

export default InternalMsg;